export { FBTMobileDrawer } from './frequently-mobile-bought-together-drawer';
